var ruler = {
  /**
   * 初始化刻度尺插件
   * @el 容器 String
   * @height 刻度尺高度 Number
   * @maxScale 最大刻度 Number
   * @startValue 开始的值 Number
   * @region 区间 Array
   * @background 刻度尺背景颜色 String
   * @color 刻度线和字体的颜色 String
   * @markColor  中心刻度标记颜色 String
   * @isConstant 是否不断地获取值 Boolean
   * @success(res) 滑动结束后的回调 Function
   * */
  initPlugin: function (params) {
    var initParams = {
      el: params.el,
      uom: params.uom || "in",
      height: params.height || 70,
      maxScale: params.maxScale || 200,
      startValue: params.startValue || 0,
      region: params.region || false,
      background: params.background || false,
      color: params.color || false,
      textColor: params.textColor || false,
      markColor: params.markColor || "#DDC9B3",
      isConstant: params.isConstant || false,
    };

    if (!initParams.el) {
      console.warn("没有容器元素的参数");
      return false;
    }

    var rulerWrap = document.getElementById(initParams.el); //获取容器
    rulerWrap.style.height =
      initParams.height < 50 ? 50 + "px" : initParams.height + "px";

    //最大刻度的小值是50
    initParams.maxScale = initParams.maxScale < 50 ? 50 : initParams.maxScale;

    if (initParams.startValue > initParams.maxScale) {
      initParams.startValue = initParams.maxScale;
    }

    var minSildeNum = 0; //最小滑动的值
    var maxSildeNum = initParams.maxScale; //最大滑动的值

    if (initParams.region) {
      minSildeNum = Math.floor(initParams.region[0]);
      maxSildeNum = Math.floor(initParams.region[1]);
    }

    var count = initParams.startValue; //初始值

    var winWidth = rulerWrap.offsetWidth; //容器宽度
    var division = winWidth / 14; //每个刻度的距离 分割线
    //刻度值数组
    var scaleValueList = [];

    switch (initParams.uom) {
      case "in":
        for (var i = 0; i <= initParams.maxScale; i++) {
          var inch =
            i / 10 > 1 ? Math.floor(i / 10) + "'" + (i % 10) + '"' : i + '"';
          scaleValueList.push(inch);
        }
        break;
      default:
        for (var i = 0; i <= initParams.maxScale; i += 3) {
          scaleValueList.push(i);
        }
    }

    var canvas = rulerWrap.getElementsByTagName("canvas")[0]; //获取容器下的canvas标签
    // 有则先移除再创建
    if (canvas) {
      rulerWrap.removeChild(canvas);
    }
    canvas = document.createElement("canvas"); //创建canvas标签
    canvas.width = winWidth;
    canvas.height = initParams.height;
    var bottomLineY = initParams.height - 8;
    rulerWrap.appendChild(canvas);
    var cxt = canvas.getContext("2d");

    //画刻度尺
    function drawRuler(count) {
      if (window.devicePixelRatio) {
        canvas.width = window.devicePixelRatio * winWidth;
        canvas.height = window.devicePixelRatio * initParams.height;
        cxt.scale(window.devicePixelRatio, window.devicePixelRatio);
      }

      if (window.devicePixelRatio) {
        canvas.style.transform = "scale(" + 1 / window.devicePixelRatio + ")";
        canvas.style.transformOrigin = "left top";
      }

      count = count - 7;

      //清空画布
      cxt.clearRect(0, 0, winWidth, initParams.height);

      //刻度尺背景
      if (initParams.background) {
        cxt.fillStyle = initParams.background;
        cxt.fillRect(0, 0, canvas.width, initParams.height);
      }

      // 画底部的双箭头线条
      drawArrow(
        cxt,
        winWidth / 2 - division * 6.99,
        bottomLineY,
        winWidth / 2 + division * 6.99,
        bottomLineY,
        undefined,
        undefined,
        undefined,
        initParams.color
      );

      //画刻度线
      for (var i = 0; i < initParams.maxScale; i++) {
        cxt.beginPath();
        cxt.save();
        cxt.strokeStyle = initParams.color ? initParams.color : "#000";
        cxt.lineWidth = 1;
        cxt.lineCap = "round";
        cxt.moveTo(division * i - count * division, bottomLineY);

        if (i % 3 !== 0 && i != 0 && i != count) {
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineY * 0.9)
          );
        }

        if (i % 3 === 0) {
          cxt.strokeStyle = initParams.color ? initParams.color : "#DDC9B3";
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineY * 0.8)
          );
        }
        /* if (i % 10 === 0) {
          cxt.strokeStyle = initParams.color ? initParams.color : "#666";
          cxt.lineTo(
            division * i - count * division,
            Math.floor(bottomLineX * 0.6)
          );
        } */

        cxt.stroke();
        cxt.restore();
        cxt.closePath();
      }

      //添加数字
      cxt.beginPath();
      cxt.font = "12px";
      cxt.fillStyle = initParams.textColor ? initParams.textColor : "#764B38";
      cxt.textAlign = "center";
      cxt.textBaseline = "middle";
      scaleValueList.forEach(function (num, i) {
        if ("in" == initParams.uom && i >= 3 && i % 3 == 0) {
          cxt.fillText(
            num.toString(),
            division * i - count * division,
            Math.floor(bottomLineY * 0.3)
          );
        } else if ("in" != initParams.uom) {
          cxt.fillText(
            num.toString(),
            division * i * 3 - count * division,
            Math.floor(bottomLineY * 0.3)
          );
        }
      });
      cxt.closePath();

      //中心刻度线
      cxt.beginPath();
      cxt.save();
      cxt.strokeStyle = initParams.markColor;
      cxt.lineWidth = 3;
      cxt.lineCap = "round";
      cxt.moveTo(winWidth / 2, bottomLineY);
      cxt.lineTo(winWidth / 2, Math.floor(bottomLineY * 0.6));
      cxt.stroke();
      cxt.restore();
      cxt.closePath();
    }

    drawRuler(count);

    function drawArrow(
      ctx,
      fromX,
      fromY,
      toX,
      toY,
      theta,
      headlen,
      width,
      color
    ) {
      theta = typeof theta != "undefined" ? theta : 40;
      headlen = typeof headlen != "undefined" ? headlen : 5;
      width = typeof width != "undefined" ? width : 1;
      color = typeof color != "undefined" ? color : "#000";

      var angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI,
        angle1 = ((angle + theta) * Math.PI) / 180,
        angle2 = ((angle - theta) * Math.PI) / 180,
        topX = headlen * Math.cos(angle1),
        topY = headlen * Math.sin(angle1),
        botX = headlen * Math.cos(angle2),
        botY = headlen * Math.sin(angle2);

      ctx.save();
      ctx.beginPath();
      // ctx.shadowColor = "#DDC9B3";
      // ctx.shadowBlur = 15;
      // ctx.shadowOffsetX = 0;
      // ctx.shadowOffsetY = 8;
      var arrowX = fromX - topX,
        arrowY = fromY - topY;
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(fromX, fromY);
      arrowX = fromX - botX;
      arrowY = fromY - botY;
      ctx.lineTo(arrowX, arrowY);
      ctx.moveTo(fromX, fromY);
      ctx.lineTo(toX, toY);

      //Reverse length on the other side
      arrowX = toX + topX;
      arrowY = toY + topY;
      ctx.moveTo(arrowX, arrowY);
      ctx.lineTo(toX, toY);
      arrowX = toX + botX;
      arrowY = toY + botY;
      ctx.lineTo(arrowX, arrowY);
      ctx.strokeStyle = color;
      ctx.lineWidth = width;
      ctx.stroke();
      ctx.restore();
    }

    var floatSeizeSeatDiv = rulerWrap.parentElement.querySelector(
      ".float-seize-seat-div"
    );
    var floatDiv;
    if (!floatSeizeSeatDiv) {
      floatSeizeSeatDiv = document.createElement("div");
      floatSeizeSeatDiv.classList.add("float-seize-seat-div");
      floatDiv = document.createElement("div");
      floatDiv.classList.add("rule-float-div");
      floatSeizeSeatDiv.appendChild(floatDiv);
      rulerWrap.append(floatSeizeSeatDiv);
    }

    floatDiv = floatSeizeSeatDiv.firstChild;
    var firstSpan = floatDiv.querySelector(".first");
    if (!firstSpan) {
      firstSpan = document.createElement("span");
      firstSpan.classList.add("first");
    }

    var secondSpan = floatDiv.querySelector(".second");
    if (!secondSpan) {
      secondSpan = document.createElement("span");
      secondSpan.classList.add("second");
    }

    var removeThirdAndFour = false;
    var thirdSpan = floatDiv.querySelector(".third");
    if (!thirdSpan) {
      thirdSpan = document.createElement("span");
      thirdSpan.classList.add("third");
    } else {
      removeThirdAndFour = true;
    }

    var fourthSpan = floatDiv.querySelector(".fourth");
    if (!fourthSpan) {
      fourthSpan = document.createElement("span");
      fourthSpan.classList.add("fourth");
    } else {
      removeThirdAndFour = true;
    }
    if (initParams.uom == "in") {
      if (initParams.startValue / 10 > 1) {
        firstSpan.textContent = Math.floor(initParams.startValue / 10);
        secondSpan.textContent = " ft ";
        thirdSpan.textContent = initParams.startValue % 10;
        fourthSpan.textContent = " in";
        floatDiv.appendChild(firstSpan);
        floatDiv.appendChild(secondSpan);
        floatDiv.appendChild(thirdSpan);
        floatDiv.appendChild(fourthSpan);
      } else {
        firstSpan.textContent = initParams.startValue + " ";
        secondSpan.textContent = initParams.uom;
        if (removeThirdAndFour) {
          floatDiv.removeChild(thirdSpan);
          floatDiv.removeChild(fourthSpan);
        }
        floatDiv.appendChild(firstSpan);
        floatDiv.appendChild(secondSpan);
      }
    } else {
      firstSpan.textContent = initParams.startValue + " ";
      secondSpan.textContent = initParams.uom;
      if (removeThirdAndFour) {
        floatDiv.removeChild(thirdSpan);
        floatDiv.removeChild(fourthSpan);
      }
      floatDiv.appendChild(firstSpan);
      floatDiv.appendChild(secondSpan);
    }
    params.success && params.success(count);

    //滑动相关
    var initX = 0, //初始x 距离
      endX = 0, //结束x 距离
      distanceX = 0, //移动距离
      _distanceX = 0, // 判断用的移动距离
      lastX = count; //上次移动距离

    if (!canvas) return false;

    //手指按下
    canvas.addEventListener(
      "touchstart",
      function (e) {
        e.preventDefault();
        initX = e.targetTouches[0].pageX;
      },
      true
    );

    //手指滑动
    canvas.addEventListener(
      "touchmove",
      function (e) {
        e.preventDefault();
        endX = e.targetTouches[0].pageX;
        moveEvent();
      },
      true
    );

    //手指抬起
    canvas.addEventListener(
      "touchend",
      function (e) {
        e.preventDefault();
        lastX = count;
        overEvent();
      },
      true
    );

    var isMouseDown = false; //鼠标是否按下

    //鼠标按下
    canvas.addEventListener(
      "mousedown",
      function (e) {
        e.preventDefault();
        isMouseDown = true;
        initX = e.layerX;
      },
      true
    );

    //鼠标移动
    canvas.addEventListener(
      "mousemove",
      function (e) {
        e.preventDefault();
        if (!isMouseDown) {
          return false;
        }
        endX = e.layerX;
        moveEvent();
      },
      true
    );

    //鼠标抬起&离开
    canvas.addEventListener(
      "mouseup",
      function (e) {
        e.preventDefault();
        lastX = count;
        isMouseDown = false;
        overEvent();
      },
      true
    );

    canvas.addEventListener(
      "mouseleave",
      function (e) {
        e.preventDefault();
        if (isMouseDown) {
          lastX = count;
          isMouseDown = false;
          overEvent();
        }
      },
      true
    );

    //手指&鼠标移动事件
    function moveEvent() {
      // 计算移动距离
      distanceX = Math.floor((initX - endX) / (winWidth / 14));
      if (distanceX === _distanceX) {
        return false;
      }
      _distanceX = distanceX;
      count = lastX + distanceX;

      // 当移动到终点或起点时，让移动总距离归为最大或零，避免选择到超过最大值或小于0的值
      if (count >= initParams.maxScale || count <= 0) {
        count = count >= initParams.maxScale ? initParams.maxScale : 0;
      }
      drawRuler(count);

      console.log("移动时：endX = " + endX + " ,initX =" + initX + " , lastX");
      if (initParams.isConstant) {
        params.success && params.success(count);
      }
    }

    //手指&鼠标结束事件
    function overEvent() {
      if (count > maxSildeNum) {
        lastX = count = count > maxSildeNum ? maxSildeNum : count;
      } else if (count < minSildeNum) {
        lastX = count = count < minSildeNum ? minSildeNum : count;
      } else {
      }
      drawRuler(count);

      //返回最后的值
      params.success && params.success(count);
    }
  },
};
(function () {
  var SELECTED_VALUES_STORAGE_KEY = 'oglmove.size.info';
  var disabledList;
  var displayedList;
  var currentValueList;
  var localSavedData;
  var current_country_code;
  var size_info;
  var sizeSelectorRoot = document.querySelector(
    '.what-my-size[data-product-id]'
  );
  var productId =
    sizeSelectorRoot?.getAttribute('data-product-id') || window.productId || '';
  var productType = sizeSelectorRoot?.getAttribute('data-product-type') || '';
  var productTypeSecond = productType.split('>')[1]?.trim();
  var productTypeThird = productType.split('>')[2]?.trim();
  var productMainImage =
    sizeSelectorRoot?.getAttribute('data-product-image') || '';
  var entryImgPath = sizeSelectorRoot?.getAttribute('data-entry-image') || '';
  var editImgPath = sizeSelectorRoot?.getAttribute('data-edit-image') || '';
  var cookieMap =
    typeof window.getCookieMap === 'function' ? window.getCookieMap() : {};
  var uid = cookieMap.uid || cookieMap._shopify_y || window.uid || '';
  var modalOverlay = document.getElementById('what-my-size-overlay');
  var modal = document.getElementById('what-my-size-modal');

  var SIZE_GUIDE_CATEGORY_MAP = {
    tops: 'Top',
    bottoms: 'Bottom',
    dresses: 'Dress',
    'tank tops': 'Tank Top',
    'bra tops': 'Bra Top',
    tees: 'Tee',
    'shirts&tops': 'Top',
    'hoodies&sweatshirts': 'Top',
    sweaters: 'Sweater',
    bodysuits: 'Bodysuit',
    cardigans: 'Cardigan',
    'jumpsuits & rompers': 'Jumpsuit',
    'mini dresses': 'Dress',
    'midi dresses': 'Dress',
    'maxi dresses': 'Dress',
    pants: 'Pants',
    shorts: 'Shorts',
    skirts: 'Skirt',
    jeans: 'Jeans',
    skorts: 'Skorts',
    'jackets & coats': 'Outerwear',
    accessories: 'Accessory'
  };

  function showWhatMySizeEntry() {
    var guideEntry = document.querySelector('.guide-entry');
    if (guideEntry) {
      guideEntry.style.display = 'flex';
    }
  }

  async function getCurrentProductRecommendSize() {
    try {
      var savedCustomerInfo = window.localStorage.getItem(
        SELECTED_VALUES_STORAGE_KEY
      );
      if (!productId || !savedCustomerInfo) {
        return null;
      }

      var customerInfo = JSON.parse(savedCustomerInfo);
      if (
        !customerInfo ||
        typeof customerInfo !== 'object' ||
        Array.isArray(customerInfo)
      ) {
        return null;
      }

      // 请求参数统一用underbust，保存都是underBust
      var requestData = {
        customer: {
          age: customerInfo.age,
          height: customerInfo.height,
          weight: customerInfo.weight,
          bodyType: customerInfo.bodyType,
          bust: customerInfo.bust,
          underbust: customerInfo.underbust,
          waist: customerInfo.waist,
          hip: customerInfo.hip,
          email: window.customer?.email || '',
          uid: window.uid || uid || ''
        },
        product: {
          id: productId
        }
      };
      var result = await window.ogl_fetch_ecowrd.post(
        '/webhook/v2/get-recommend-size',
        requestData
      );

      if (
        result &&
        result.code === 0 &&
        Array.isArray(result.data) &&
        result.data.length
      ) {
        var resultContainer =
          document.getElementById('what-my-size-container') ||
          document.getElementById('recommend-size-container');
        var modalFooter = modal?.querySelector('.modal-footer');
        if (modalFooter) {
          modalFooter.style.display = 'none';
        }

        createRecommendSize(resultContainer, result.data, result.msg);
      }

      return result;
    } catch (error) {
      console.error('Failed to get the current product recommendation:', error);
      return null;
    } finally {
      showWhatMySizeEntry();
    }
  }

  function showModal(entryPage) {
    if (!modalOverlay || !modal) {
      return;
    }

    modalOverlay.style.display = 'block';
    modal.style.display = 'block';
    if (
      !document.querySelector('#what-my-size-container #height-select-container')
    ) {
      createHeightDiv();
      updateSteps(1);
    }

    var header = document.getElementById('shopify-section-header-inline');
    if (header) {
      header.style.zIndex = 0;
    }

    disableScroll();
    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('details_sizerecom_spuid_btn', {
        product_id: productId,
        entry_page: entryPage
      });
    }

    var sizeGuide = document.querySelector('.t4sp-theme .mfp-wrap');
    var sizeGuideOverlay = document.querySelector(
      '.mfp-move-horizontal.mfp-ready.mfp-bg'
    );
    if (sizeGuide) {
      sizeGuide.style.display = 'none';
    }
    if (sizeGuideOverlay) {
      sizeGuideOverlay.style.display = 'none';
    }
  }

  function closeModal() {
    if (!modalOverlay || !modal) {
      return;
    }

    modalOverlay.style.display = 'none';
    modal.style.display = 'none';

    var header = document.getElementById('shopify-section-header-inline');
    if (header) {
      header.style.zIndex = 460;
    }

    enableScroll();
    scrollToAnchor('what-my-size-entry');

    var sizeGuide = document.querySelector('.t4sp-theme .mfp-wrap');
    var sizeGuideOverlay = document.querySelector(
      '.mfp-move-horizontal.mfp-ready.mfp-bg'
    );
    if (sizeGuide) {
      sizeGuide.style.display = 'block';
      sizeGuide.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
    if (sizeGuideOverlay) {
      sizeGuideOverlay.style.display = 'block';
    }
  }

  function disableScroll() {
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.right = 0;
    document.body.style.left = 0;
  }

  function enableScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
  }

  function scrollToAnchor(anchorId) {
    var anchorElement = document.getElementById(anchorId);
    if (anchorElement) {
      anchorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  }

  function setWhatMySizeEntryTitle(recommendations) {
    if (!Array.isArray(recommendations) || !recommendations.length) {
      showWhatMySizeEntry();
      return;
    }

    var validRecommendations = recommendations.filter(
      (recommendation) =>
        recommendation &&
        typeof recommendation === 'object' &&
        String(recommendation.category || '').trim() &&
        String(recommendation.size || '').trim()
    );
    if (!validRecommendations.length) {
      showWhatMySizeEntry();
      return;
    }

    var title = document.querySelector('.guide-entry .title');
    if (!title) {
      showWhatMySizeEntry();
      return;
    }

    var recommendationText = validRecommendations
      .map((recommendation) => {
        var category = String(recommendation.category).trim();
        var categoryName =
          SIZE_GUIDE_CATEGORY_MAP[category.toLowerCase()] || category;

        return categoryName + ': ' + String(recommendation.size).trim();
      })
      .join(' / ');

    var sizeText = document.createElement('span');
    sizeText.classList.add('span-size');
    sizeText.style.fontWeight = 800;
    sizeText.textContent = recommendationText;

    var recommendationLabel = document.createElement('span');
    recommendationLabel.classList.add('span-recom');
    recommendationLabel.style.fontWeight = 100;
    recommendationLabel.textContent =
      validRecommendations.length > 1
        ? ' are Recommendations.'
        : ' is Recommendation.';

    var editText = document.createElement('span');
    editText.classList.add('edit-text');
    editText.textContent = ' Edit Info';

    title.replaceChildren(sizeText, recommendationLabel, editText);
    title.style.textDecoration = 'none';
  }

  window.getCurrentProductRecommendSize = getCurrentProductRecommendSize;
  window.showModal = showModal;
  window.closeModal = closeModal;
  // window.setWhatMySizeEntryTitle = setWhatMySizeEntryTitle;

  var closeButton = sizeSelectorRoot?.querySelector('.close-button');
  if (closeButton) {
    closeButton.addEventListener('click', closeModal);
  }

  function createStepState() {
    return {
      weight: false,
      height: false,
      age: false,
      bodyType: false,
      bodySize: false
    };
  }

  function createDefaultCurrentValues() {
    return {
      weight: { value: 0, unit: '' },
      height: { value: 0, unit: '' },
      age: 22,
      bodyType: '',
      bust: { value: 0, unit: '' },
      underbust: { value: 0, unit: '' },
      waist: { value: 0, unit: '' },
      hip: { value: 0, unit: '' }
    };
  }

  function initializeSelectorState() {
    // 答复框是否可编辑状态
    disabledList = createStepState();

    // 选择器是否已创建的状态
    displayedList = createStepState();

    currentValueList = createDefaultCurrentValues();
    localSavedData = window.localStorage.getItem(SELECTED_VALUES_STORAGE_KEY);

    current_country_code = window.ogl_size_config?.country || 'US';
    window.initSizeInfo && (size_info = window.initSizeInfo(window.size_guide_clicked_product));
    console.log('size_info', size_info)
    if (localSavedData) {
      updateSelectedValue(localSavedData);
    }
    // 初始化更新title
    getCurrentProductRecommendSize();
  }

  initializeSelectorState();

  function formatInchValue(value) {
    return value / 10 > 1
      ? Math.floor(value / 10) + "'" + (value % 10) + '"'
      : value + '"';
  }

  function formatDecimalValue(value) {
    return parseFloat(value.toFixed(2));
  }

  var RULER_CONFIG = {
    height: {
      in: {
        stateUnit: 'in',
        startValue: 54,
        maxScale: 100,
        formatValue: formatInchValue,
        formatPopText: (value) => 'I am ' + value
      },
      cm: {
        stateUnit: 'cm',
        startValue: 165,
        maxScale: 250,
        formatValue: formatDecimalValue,
        formatPopText: (value) => 'I am ' + value + ' cm'
      }
    },
    weight: {
      lb: {
        stateUnit: 'lb',
        startValue: 120,
        maxScale: 300,
        formatValue: formatDecimalValue,
        formatPopText: (value) => 'I weigh ' + value + ' lb'
      },
      kg: {
        stateUnit: 'kg',
        startValue: 55,
        maxScale: 150,
        formatValue: formatDecimalValue,
        formatPopText: (value) => 'I weigh ' + value + ' kg'
      }
    }
  };

  function hasPopDiv(containerId) {
    var container = document.getElementById(containerId);
    var parentElement = container && container.parentElement;
    var popContainer = parentElement && parentElement.nextElementSibling;

    return Boolean(
      popContainer &&
      popContainer.classList.contains('seize-a-seat') &&
      popContainer.querySelector('.pop-range, .pop-range-light')
    );
  }

  function drawRule(containerId, stateKey, unit, options) {
    options = options || {};
    var stateConfig = RULER_CONFIG[stateKey];
    var config = stateConfig && stateConfig[unit];
    if (!config) {
      console.warn('Unsupported ruler config:', stateKey, unit);
      return;
    }

    var currentState = currentValueList[stateKey];
    var startValue = config.startValue;
    if (
      currentState &&
      currentState.unit === config.stateUnit &&
      typeof currentState.value === 'number' &&
      currentState.value
    ) {
      startValue = currentState.value;
    }

    ruler.initPlugin({
      el: containerId,
      uom: config.rulerUnit || unit,
      startValue: startValue,
      maxScale: config.maxScale,
      region: config.region,
      background: '#fbf6ed',
      markColor: '#DDC9B3',
      color: '#DDC9B3',
      isConstant: true,
      success: function (value) {
        console.log('addPopDiv success ruler');
        if (config.region) {
          value = Math.min(config.region[1], Math.max(config.region[0], value));
        }

        displayFloatText(containerId, value, config.displayUnit || unit);

        var formattedValue = config.formatValue(value);
        var disabledStateKey = options.disabledStateKey || stateKey;
        if (disabledList[disabledStateKey]) {
          return;
        }

        var valueChanged =
          currentState.value !== formattedValue ||
          currentState.unit !== config.stateUnit;
        if (valueChanged) {
          currentState.value = formattedValue;
          currentState.unit = config.stateUnit;
          saveCurrentValues();
        }

        var popContainerId = options.popContainerId || containerId;
        if (
          !valueChanged &&
          !options.updatePopWhenUnchanged &&
          hasPopDiv(popContainerId)
        ) {
          return;
        }

        console.log('addPopDiv=======');
        addPopDiv(
          popContainerId,
          options.getPopText
            ? options.getPopText()
            : config.formatPopText(formattedValue),
          options.popType || stateKey
        );
      }
    });
  }

  function saveCurrentValues() {
    var valuesToSave = {
      weight: currentValueList.weight,
      height: currentValueList.height,
      age: currentValueList.age,
      bodyType: currentValueList.bodyType,
      bust: currentValueList.bust,
      underbust: currentValueList.underbust,
      waist: currentValueList.waist,
      hip: currentValueList.hip
    };
    var serializedValues = JSON.stringify(valuesToSave);
    window.localStorage.setItem(SELECTED_VALUES_STORAGE_KEY, serializedValues);
    return serializedValues;
  }

  function updateSelectedValue(localSavedData) {
    if (!localSavedData) {
      return;
    }

    try {
      var savedData = JSON.parse(localSavedData);
      if (!savedData || typeof savedData !== 'object') {
        return;
      }

      var defaultValues = createDefaultCurrentValues();
      currentValueList = Object.assign(defaultValues, {
        age:
          typeof savedData.age === 'undefined'
            ? defaultValues.age
            : savedData.age,
        bodyType:
          typeof savedData.bodyType === 'string'
            ? savedData.bodyType
            : defaultValues.bodyType,
        height: Object.assign({}, defaultValues.height, savedData.height || {}),
        weight: Object.assign({}, defaultValues.weight, savedData.weight || {}),
        bust: Object.assign(
          {},
          defaultValues.bust,
          typeof savedData.bust === 'object' ? savedData.bust : {}
        ),
        underbust: Object.assign(
          {},
          defaultValues.underbust,
          typeof savedData.underbust === 'object' ? savedData.underbust : {}
        ),
        waist: Object.assign(
          {},
          defaultValues.waist,
          typeof savedData.waist === 'object' ? savedData.waist : {}
        ),
        hip: Object.assign(
          {},
          defaultValues.hip,
          typeof savedData.hip === 'object' ? savedData.hip : {}
        )
      });
      localSavedData = saveCurrentValues();
    } catch (error) {
      console.warn('Invalid saved size data:', error);
    }
  }

  function updateSteps(steps) {
    var stepsDiv = document.querySelectorAll(
      ".bs-stepper-header *:not([style*='display: none']):not(button):not(span)"
    );

    for (let i = 0; i < steps; i++) {
      const index = i * 2;
      const circleDiv = stepsDiv[index];
      const line = stepsDiv[index - 1];

      if (circleDiv) {
        const circle = circleDiv.querySelector('.bs-stepper-circle');
        circle.style.color = '#fff';
        circle.textContent = i === steps - 1 ? '' : '✔';
        circle.style.backgroundColor = 'var(--what-my-size-main-color)';
      }

      if (line) {
        line.style.backgroundColor = 'var(--what-my-size-main-color)';
      }
    }

    for (let i = steps; i <= stepsDiv.length / 2; i++) {
      const index = i * 2;
      const circleDiv = stepsDiv[index];
      const line = stepsDiv[index - 1];

      if (circleDiv) {
        const circle = circleDiv.querySelector('.bs-stepper-circle');
        circle.style.backgroundColor = 'var(--what-my-size-sub-color)';
        circle.textContent = '';
      }

      if (line) {
        line.style.backgroundColor = 'var(--what-my-size-sub-color)';
      }
    }
  }

  function getCountrySizeValue(size) {
    const sizeKey = String(size || '').trim();
    if (!sizeKey) return undefined;
    return size_info?.country_size_json?.[sizeKey]?.[current_country_code];
  }

  var submitUrl = '/webhook/v2/recommend-size';
  var submitEmail = '/webhook/email-report';
  var requestBody = {
    customer: {
      height: {
        value: 175,
        unit: 'cm'
      },
      weight: {
        value: 42,
        unit: 'kg'
      },
      age: 32,
      bodyType: '',
      bust: { value: 0, unit: '' },
      underbust: { value: 0, unit: '' },
      waist: { value: 0, unit: '' },
      hip: { value: 0, unit: '' },
      uid: uid
    },
    product: {
      id: productId
    }
  };

  // 观察器的配置（需要观察哪些属性）
  var sizeSelectorObserverConfig = {
    attributes: true,
    attributeOldValue: true,
    attributeFilter: ['style']
  };

  var currentObserverNode;
  var sizeSelectorObserver = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        const opacity = currentObserverNode.style.opacity;
        if (opacity === '0') {
          currentObserverNode.style.display = 'none';
          sizeSelectorObserver.disconnect();
        }
      }
    }
  });

  // 创建身高选择器
  function createHeightDiv() {
    var subSizeContainer;
    if (!displayedList.height) {
      const whatSizeContainer = document.getElementById(
        'what-my-size-container'
      );
      if (!whatSizeContainer) {
        console.warn(
          '缺少容器元素，请添加id为what-my-size-container的容器元素'
        );
        return false;
      }

      var mainTitleText = 'How tall are you?';
      var subTitleText = 'This helps your profile take shape.';
      var rulerContainerId = 'height-ruler';
      var btnGroupName = 'height-uom';

      subSizeContainer = document.createElement('div');
      subSizeContainer.classList.add('size-sub-container');
      subSizeContainer.setAttribute('id', 'height-select-container');
      whatSizeContainer.appendChild(subSizeContainer);

      createMainTitle(subSizeContainer, mainTitleText);
      createSubTitle(subSizeContainer, subTitleText);
      createRuleContainer(subSizeContainer, rulerContainerId);
      drawRule(rulerContainerId, 'height', 'in');
      createRuleBtns(subSizeContainer, btnGroupName, ['in', 'cm'], 'in');
      addBtnsListener(btnGroupName, rulerContainerId, 'height');
      displayedList.height = true;
    } else {
      subSizeContainer = document.getElementById('height-select-container');
    }
    return subSizeContainer;
  }

  // 创建体重选择器
  function createWeightDiv() {
    var subSizeContainer;
    if (!displayedList.weight) {
      const whatSizeContainer = document.getElementById(
        'what-my-size-container'
      );
      if (!whatSizeContainer) {
        console.warn(
          '缺少容器元素，请添加id为what-my-size-container的容器元素'
        );
        return false;
      }

      var mainTitleText = 'What do you weigh?';
      var subTitleText = "It's just one factor in understanding fit.";
      var rulerContainerId = 'weight-ruler';
      var btnGroupName = 'weight-uom';

      subSizeContainer = document.createElement('div');
      subSizeContainer.classList.add('size-sub-container');
      subSizeContainer.setAttribute('id', 'weight-select-container');
      whatSizeContainer.appendChild(subSizeContainer);

      createMainTitle(subSizeContainer, mainTitleText);
      createSubTitle(subSizeContainer, subTitleText);
      createRuleContainer(subSizeContainer, rulerContainerId);
      drawRule(rulerContainerId, 'weight', 'lb');
      createRuleBtns(subSizeContainer, btnGroupName, ['lb', 'kg'], 'lb');
      addBtnsListener(btnGroupName, rulerContainerId, 'weight');
      displayedList.weight = true;
    } else {
      subSizeContainer = document.getElementById('weight-select-container');
    }

    return subSizeContainer;
  }

  // 创建年龄选择器
  function createAgeSelector() {
    var subSizeContainer;
    if (!displayedList.age) {
      const whatSizeContainer = document.getElementById(
        'what-my-size-container'
      );
      if (!whatSizeContainer) {
        console.warn(
          '缺少容器元素，请添加id为what-my-size-container的容器元素'
        );
        return false;
      }

      var mainTitleText = "What's your age?";
      var subTitleText = 'Age can impact body shape and how some brands fit.';
      subSizeContainer = document.createElement('div');
      subSizeContainer.classList.add('size-sub-container');
      subSizeContainer.setAttribute('id', 'age-select-container');
      whatSizeContainer.appendChild(subSizeContainer);

      createMainTitle(subSizeContainer, mainTitleText);
      createSubTitle(subSizeContainer, subTitleText);
      createAgeBtns(subSizeContainer);
      displayedList.age = true;
    } else {
      subSizeContainer = document.getElementById('age-select-container');
    }

    return subSizeContainer;
  }

  // 创建身材选择器
  function createBodyTypeSelector() {
    var subSizeContainer;
    if (!displayedList.bodyType) {
      const whatSizeContainer = document.getElementById(
        'what-my-size-container'
      );
      if (!whatSizeContainer) {
        console.warn(
          '缺少容器元素，请添加id为what-my-size-container的容器元素'
        );
        return false;
      }

      var mainTitleText = "What's your body type?";
      var subTitleText =
        'This will assist us in suggesting the most suitable styles for you.';
      subSizeContainer = document.createElement('div');
      subSizeContainer.classList.add('size-sub-container');
      subSizeContainer.setAttribute('id', 'body-type-select-container');
      whatSizeContainer.appendChild(subSizeContainer);

      createMainTitle(subSizeContainer, mainTitleText);
      createSubTitle(subSizeContainer, subTitleText);
      createBodyTypeBtns(subSizeContainer);
      displayedList.bodyType = true;
    } else {
      subSizeContainer = document.getElementById('body-type-select-container');
    }

    return subSizeContainer;
  }

  // 创建身体尺寸选择器
  function createBodySizeSelector() {
    var subSizeContainer;
    if (!displayedList.bodySize) {
      const whatSizeContainer = document.getElementById(
        'what-my-size-container'
      );
      if (!whatSizeContainer) {
        console.warn(
          '缺少容器元素，请添加id为what-my-size-container的容器元素'
        );
        return false;
      }

      var mainTitleText = "What's your size?";
      subSizeContainer = document.createElement('div');
      subSizeContainer.classList.add('size-sub-container');
      subSizeContainer.setAttribute('id', 'body-size-select-container');
      whatSizeContainer.appendChild(subSizeContainer);

      createMainTitle(subSizeContainer, mainTitleText);
      createBodySizeBtns(subSizeContainer);
      displayedList.bodySize = true;
    } else {
      subSizeContainer = document.getElementById('body-size-select-container');
    }

    return subSizeContainer;
  }

  // 创建选择器的主标题
  function createMainTitle(parentElement, text) {
    var mainTitle = document.createElement('h2');
    mainTitle.classList.add('main-title');
    mainTitle.textContent = text;
    parentElement.appendChild(mainTitle);
  }

  // 创建选择器的副标题
  function createSubTitle(parentElement, html) {
    var subTitle = document.createElement('div');
    subTitle.classList.add('sub-title');
    subTitle.innerHTML = html;
    parentElement.append(subTitle);
  }

  // 创建刻度尺容器
  function createRuleContainer(parentElement, containerId) {
    var container = document.createElement('div');
    container.classList.add('ruler-wrap', 'bounce-in');
    container.setAttribute('id', containerId);
    parentElement.appendChild(container);
  }

  // 创建刻度尺切换按钮
  function createRuleBtns(parentElement, btnGroupName, uomArr, defaultUom) {
    var ruleBtnDiv = document.createElement('div');
    ruleBtnDiv.classList.add('ruler-btn-wrap');
    var ruleBtnGroup = document.createElement('div');
    ruleBtnGroup.classList.add('btn-group', 'btn-group-lg');
    ruleBtnGroup.setAttribute('role', 'group');
    for (let uom of uomArr) {
      var btnRadio = document.createElement('input');
      var btnId = btnGroupName + '-' + uom;
      btnRadio.classList.add('btn-check');
      btnRadio.setAttribute('type', 'radio');
      btnRadio.setAttribute('name', btnGroupName);
      btnRadio.setAttribute('id', btnId);
      btnRadio.setAttribute('value', uom);
      btnRadio.setAttribute('autocomplete', 'off');
      if (defaultUom === uom) {
        btnRadio.setAttribute('checked', true);
      }
      var btnLabel = document.createElement('label');
      btnLabel.classList.add('btn', 'btn-outline-info', 'ruler-btn');
      btnLabel.setAttribute('for', btnId);
      btnLabel.textContent = uom;
      ruleBtnGroup.appendChild(btnRadio);
      ruleBtnGroup.appendChild(btnLabel);
    }

    ruleBtnDiv.appendChild(ruleBtnGroup);
    parentElement.appendChild(ruleBtnDiv);
  }

  // 为刻度尺切换按钮添加点击事件监听器
  function addBtnsListener(btnGroupName, rulerContainerId, stateKey, options) {
    const rulerBtns = document.querySelectorAll(
      'input[name=' + btnGroupName + ']'
    );
    rulerBtns.forEach((element) => {
      element.addEventListener('click', (event) => {
        drawRule(rulerContainerId, stateKey, event.target.value, options);
      });
    });
  }

  // 显示刻度尺上的值
  function displayFloatText(containerId, value, uom) {
    const parentElement = document.getElementById(containerId);
    const floatDiv = parentElement.querySelector(
      '.float-seize-seat-div .rule-float-div'
    );
    const parts =
      uom === 'in' && value / 10 > 1
        ? [
          { className: 'first', text: Math.floor(value / 10) },
          { className: 'second', text: ' ft ' },
          { className: 'third', text: value % 10 },
          { className: 'fourth', text: ' in' }
        ]
        : [
          { className: 'first', text: value + ' ' },
          { className: 'second', text: uom }
        ];

    floatDiv.replaceChildren();
    for (const part of parts) {
      const span = document.createElement('span');
      span.classList.add(part.className);
      span.textContent = part.text;
      floatDiv.appendChild(span);
    }
  }

  // 滚动到指定元素位置
  function scrollToElement(anchorId) {
    const targetElement = document.getElementById(anchorId);
    const scrollContainer = document.querySelector(
      '.what-my-size .modal-content'
    );

    if (targetElement && scrollContainer) {
      const targetRect = targetElement.getBoundingClientRect();
      const containerRect = scrollContainer.getBoundingClientRect();
      const scrollTop =
        scrollContainer.scrollTop + targetRect.top - containerRect.top;

      scrollContainer.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  }

  // 添加确认用户所选值的气泡组件
  var count = 0;
  function addPopDiv(rulerContainerId, text, type) {
    var weightDiv, ageDiv, bodyTypeDiv, bodySizeDiv;
    const container = document.getElementById(rulerContainerId);
    const parentElement = container.parentElement;
    var seizeASeatDiv = parentElement.nextElementSibling;
    var popDiv, textDiv, entryBtn, entryBtnImg, editBtn, editBtnImg;

    if (!seizeASeatDiv || !seizeASeatDiv.classList.contains('seize-a-seat')) {
      count++;
      seizeASeatDiv = document.createElement('div');
      seizeASeatDiv.classList.add('seize-a-seat');
      if (count !== 1) {
        seizeASeatDiv.style.transform = parentElement.style.transform;
      }
      parentElement.parentElement.append(seizeASeatDiv);

      popDiv = document.createElement('div');
      popDiv.classList.add('pop-range');
      popDiv.setAttribute('id', 'pop-div-' + count);
      popDiv.dataset.mode = 'new';
      popDiv.title = 'Continue';
      seizeASeatDiv.appendChild(popDiv);

      textDiv = document.createElement('div');
      textDiv.classList.add('response-text');
      popDiv.appendChild(textDiv);

      entryBtn = document.createElement('button');
      entryBtn.classList.add(
        'btn',
        'btn-outline-info',
        'response-btn',
        'entry-btn'
      );
      entryBtn.type = 'button';
      entryBtn.setAttribute('sort', count);
      entryBtn.setAttribute('aria-label', 'Continue');
      popDiv.appendChild(entryBtn);

      entryBtnImg = document.createElement('img');
      entryBtnImg.classList.add('pop-btn-img');
      entryBtnImg.setAttribute('src', entryImgPath);
      entryBtn.appendChild(entryBtnImg);

      editBtn = document.createElement('button');
      editBtn.classList.add(
        'btn',
        'btn-outline-info',
        'response-btn',
        'edit-btn'
      );
      editBtn.setAttribute('sort', count);
      editBtn.type = 'button';
      editBtn.setAttribute('aria-label', 'Edit selection');

      editBtnImg = document.createElement('img');
      editBtnImg.setAttribute('src', editImgPath);
      editBtn.appendChild(editBtnImg);
      editBtn.style.borderColor = '#DDC9B3';
      editBtn.style.backgroundColor = '#DDC9B3';
      editBtn.style.display = 'none';
      popDiv.appendChild(editBtn);

      function continueToNextStep() {
        var activeSizeContainer;

        popDiv.style.backgroundColor = '#DDC9B3';
        entryBtn.style.backgroundColor = '#DDC9B3';
        entryBtn.style.borderColor = '#DDC9B3';
        textDiv.style.backgroundColor = '#DDC9B3';
        editBtnImg.style.backgroundColor = '#DDC9B3';

        popDiv.classList.add('pop-range-light');
        popDiv.classList.remove('pop-range');
        popDiv.dataset.mode = 'confirmed';
        popDiv.title = 'Edit selection';

        // 获取父级组件的高度便于上下移动
        var computedStyle = window.getComputedStyle(container.previousSibling);
        var computedStyleHeight = 0;

        if (computedStyle) {
          computedStyleHeight = parseInt(
            computedStyle.getPropertyValue('height'),
            10
          );
        }

        var curPopComStyle = window.getComputedStyle(seizeASeatDiv);
        var curPopComHeight = parseInt(
          curPopComStyle.getPropertyValue('height'),
          10
        );

        currentObserverNode = parentElement;
        sizeSelectorObserver.observe(parentElement, sizeSelectorObserverConfig);

        var distanceFromTop = computedStyleHeight - curPopComHeight * count;
        parentElement.style.transform =
          'translateY(-' + distanceFromTop + 'px)';
        parentElement.style.opacity = 0;
        var popMoveDistance =
          computedStyleHeight - (curPopComHeight * (count - 1) + 20);
        seizeASeatDiv.style.transform =
          'translateY(-' + popMoveDistance + 'px)';

        // 这里的type，是当前点击的type，所以处理的逻辑是下一步的逻辑
        switch (type) {
          case 'height':
            disabledList.height = true;
            weightDiv = createWeightDiv();
            activeSizeContainer = weightDiv;
            weightDiv.style.transform =
              'translateY(-' + distanceFromTop + 'px)';
            break;
          case 'weight':
            disabledList.weight = true;
            ageDiv = createAgeSelector();
            activeSizeContainer = ageDiv;
            ageDiv.style.transform = 'translateY(-' + distanceFromTop + 'px)';
            break;
          case 'age':
            disabledList.age = true;
            bodySizeDiv = createBodySizeSelector();
            activeSizeContainer = bodySizeDiv;
            bodySizeDiv.style.transform =
              'translateY(-' + distanceFromTop + 'px)';
            break;
          case 'bodySize':
            disabledList.bodySize = true;
            bodyTypeDiv = createBodyTypeSelector();
            activeSizeContainer = bodyTypeDiv;
            bodyTypeDiv.style.transform =
              'translateY(-' + distanceFromTop + 'px)';
            break;
          case 'bodyType':
            disabledList.bodyType = true;
            submitInfoToBack(parentElement.parentElement);
            break;
        }
        entryBtn.style.display = 'none';
        editBtn.style.display = 'inline-block';
        editBtn.style.backgroundColor = '#DDC9B3';
        editBtn.style.borderColor = '#DDC9B3';
        try {
          var sort = parseInt(entryBtn.getAttribute('sort'));
          updateSteps(sort + 1);
        } catch (error) {
          console.warn('Failed to update size steps:', error);
        }

        if (activeSizeContainer) {
          window.requestAnimationFrame(() => {
            scrollToElement(activeSizeContainer.id);
          });
        }
      }

      function editCurrentStep() {
        popDiv.style.backgroundColor = '#764B38';
        editBtn.style.backgroundColor = '#764B38';
        editBtn.style.borderColor = '#764B38';
        textDiv.style.backgroundColor = '#764B38';
        editBtnImg.style.backgroundColor = '#764B38';
        popDiv.classList.add('pop-range');
        popDiv.classList.remove('pop-range-light');
        popDiv.dataset.mode = 'editing';
        popDiv.title = 'Continue';
        seizeASeatDiv.style.transform = 'translateY(0)';
        parentElement.style.opacity = 1;
        parentElement.style.display = 'block';
        switch (type) {
          case 'height':
            disabledList.height = false;
            weightDiv.style.transform = 'translateY(0)';
            break;
          case 'weight':
            disabledList.weight = false;
            ageDiv.style.transform = 'translateY(0)';
            break;
          case 'age':
            disabledList.age = false;
            bodySizeDiv.style.transform = 'translateY(0)';
            break;
          case 'bodySize':
            disabledList.bodySize = false;
            bodyTypeDiv.style.transform = 'translateY(0)';
            break;
          case 'bodyType':
            disabledList.bodyType = false;
            break;
        }
        editBtn.style.display = 'none';
        entryBtn.style.display = 'inline-block';
        entryBtn.style.backgroundColor = '#764B38';
        entryBtn.style.borderColor = '#764B38';
        try {
          var sort = parseInt(editBtn.getAttribute('sort'));
          updateSteps(sort);
        } catch (error) {
          console.warn('Failed to update size steps:', error);
        }
      }

      popDiv.addEventListener('click', (event) => {
        event.preventDefault();

        if (popDiv.dataset.mode === 'confirmed') {
          editCurrentStep();
          return;
        }

        continueToNextStep();
      });
    } else {
      popDiv =
        seizeASeatDiv.querySelector('.pop-range') ||
        seizeASeatDiv.querySelector('.pop-range-light');
      textDiv = popDiv.querySelector('.response-text');
      entryBtn = popDiv.querySelector('.entry-btn');
      editBtn = popDiv.querySelector('.edit-btn');
    }
    textDiv.textContent = text;
  }

  // 创建body type选项按钮
  function createBodyTypeBtns(parentElement) {
    var bodyTypeBtnsDiv = document.createElement('div');
    bodyTypeBtnsDiv.classList.add('select-body-type-btns');
    bodyTypeBtnsDiv.id = 'body-type-wrap';
    var bodyTypeList = [
      {
        imgUrl:
          'https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_Hourglass.png?v=1784785899',
        text: 'Hourglass'
      },
      {
        imgUrl:
          'https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_Pear.png?v=1784785899',
        text: 'Pear'
      },
      {
        imgUrl:
          'https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_Inverted_Triangle.png?v=1784785899',
        text: 'Inverted Triangle'
      },
      {
        imgUrl:
          'https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_Apple.png?v=1784785899',
        text: 'Apple'
      },
      {
        imgUrl:
          'https://cdn.shopify.com/s/files/1/0506/5284/0124/files/body_Rectangle.png?v=1784785899',
        text: 'Rectangle'
      }
    ];

    bodyTypeList.forEach((bodyType, index) => {
      var bodyTypeBtn = document.createElement('input');
      bodyTypeBtn.classList.add('btn-check');
      bodyTypeBtn.type = 'radio';
      bodyTypeBtn.name = 'body-type-btn';
      bodyTypeBtn.id = 'body-type-option-' + index;
      bodyTypeBtn.value = bodyType.text;
      bodyTypeBtn.autocomplete = 'off';

      var bodyTypeBtnLabel = document.createElement('label');
      bodyTypeBtnLabel.classList.add('body-type-btn');
      bodyTypeBtnLabel.setAttribute('for', bodyTypeBtn.id);

      var bodyTypeImg = document.createElement('img');
      bodyTypeImg.classList.add('body-type-btn-img');
      bodyTypeImg.src = bodyType.imgUrl;
      bodyTypeImg.alt = bodyType.text + ' body type';
      bodyTypeImg.decoding = 'async';

      var bodyTypeText = document.createElement('span');
      bodyTypeText.classList.add('body-type-btn-text');
      bodyTypeText.textContent = bodyType.text;

      bodyTypeBtnLabel.appendChild(bodyTypeImg);
      bodyTypeBtnLabel.appendChild(bodyTypeText);
      bodyTypeBtnsDiv.appendChild(bodyTypeBtn);
      bodyTypeBtnsDiv.appendChild(bodyTypeBtnLabel);

      bodyTypeBtn.addEventListener('click', () => {
        currentValueList.bodyType = bodyType.text;
        saveCurrentValues();
        addPopDiv(
          bodyTypeBtnsDiv.id,
          'My body type is ' + bodyType.text,
          'bodyType'
        );
      });
    });

    parentElement.appendChild(bodyTypeBtnsDiv);
    setTimeout(() => {
      if (!bodyTypeBtnsDiv.querySelector('input:checked')) {
        addPopDiv(bodyTypeBtnsDiv.id, 'Rather not say', 'bodyType');
      }
    }, 500);
  }

  // 创建年龄区间按钮选择器
  function createAgeBtns(parentElement) {
    var ageBtnsDiv = document.createElement('div');
    ageBtnsDiv.classList.add('select-age-btns');
    ageBtnsDiv.id = 'age-wrap';
    var textArr = ['16-18', '19-24', '25-34', '35-44', '45-54', '55-64', '65+'];

    textArr.forEach((ageRange, index) => {
      var ageBtn = document.createElement('input');
      ageBtn.classList.add('btn-check');
      ageBtn.type = 'radio';
      ageBtn.name = 'age-btn';
      ageBtn.id = 'age-option-' + index;
      ageBtn.autocomplete = 'off';

      var ageBtnLabel = document.createElement('label');
      ageBtnLabel.classList.add('btn', 'btn-light');
      ageBtnLabel.setAttribute('for', ageBtn.id);
      ageBtnLabel.textContent = ageRange;
      ageBtnsDiv.appendChild(ageBtn);
      ageBtnsDiv.appendChild(ageBtnLabel);

      ageBtn.addEventListener('click', () => {
        currentValueList.age = ageRange;
        saveCurrentValues();

        var text;
        if (ageRange.includes('-')) {
          var rangeValues = ageRange.split('-');
          text =
            'My age is between ' + rangeValues[0] + ' and ' + rangeValues[1];
        } else {
          text = 'My age is ' + ageRange;
        }
        addPopDiv(ageBtnsDiv.id, text, 'age');
      });
    });

    parentElement.appendChild(ageBtnsDiv);
    setTimeout(() => {
      if (!ageBtnsDiv.querySelector('input:checked')) {
        addPopDiv(ageBtnsDiv.id, 'Rather not say', 'age');
      }
    }, 500);
  }

  function getCurrentProductMetafields() {
    var productElements = document.querySelectorAll(
      'div[data-product-featured][data-product-id]'
    );

    for (var productElement of productElements) {
      if (String(productElement.dataset.productId) !== String(productId)) {
        continue;
      }

      var metafieldElement = productElement.querySelector('.pr_metafield_json');
      if (!metafieldElement) {
        continue;
      }

      try {
        return JSON.parse(metafieldElement.textContent || '{}');
      } catch (error) {
        console.warn('Invalid product metafield data:', error);
        return {};
      }
    }

    return {};
  }

  function isBramiProduct() {
    var metafields = getCurrentProductMetafields();
    var hasBra =
      metafields.operation_filter && metafields.operation_filter.has_bra;

    return (
      String(hasBra || '')
        .trim()
        .toLowerCase() === 'brami'
    );
  }

  function formatBodySizePopText(measurements) {
    return measurements
      .filter((measurement) => {
        var state = currentValueList[measurement.stateKey];
        return state && state.value && state.unit;
      })
      .map((measurement) => {
        var state = currentValueList[measurement.stateKey];
        return (
          measurement.label +
          ': ' +
          state.value +
          ' ' +
          state.unit.toUpperCase()
        );
      })
      .join(', ');
  }

  function createMeasurementValues(minValue, maxValue) {
    var values = [];
    for (var value = minValue; value <= maxValue; value++) {
      values.push(value);
    }
    return values;
  }

  function getBodyMeasurementValue(inchValue, unit) {
    return unit === 'cm' ? Math.round(inchValue * 2.54) : inchValue;
  }

  function convertBodyMeasurementValue(value, fromUnit, toUnit) {
    if (!value || !fromUnit || fromUnit === toUnit) {
      return Number(value);
    }

    return toUnit === 'cm'
      ? Math.round(Number(value) * 2.54)
      : Math.round(Number(value) / 2.54);
  }

  function createBodyMeasurementTable(
    parentElement,
    measurement,
    unit,
    onChange
  ) {
    var table = document.createElement('table');
    table.classList.add('body-size-table');
    table.setAttribute('role', 'group');
    table.setAttribute(
      'aria-label',
      measurement.label + (unit === 'cm' ? ' in centimeters' : ' in inches')
    );

    var titleRow = document.createElement('tr');
    var titleCell = document.createElement('th');
    titleCell.classList.add('body-size-table-title');
    titleCell.colSpan = 3;
    titleCell.scope = 'colgroup';
    titleCell.textContent = measurement.label + ' (' + unit.toUpperCase() + ')';
    titleRow.appendChild(titleCell);
    table.appendChild(titleRow);

    var currentState = currentValueList[measurement.stateKey];
    var values = createMeasurementValues(
      measurement.minValue,
      measurement.maxValue
    );

    for (
      var rowIndex = 0;
      rowIndex < Math.ceil(values.length / 3);
      rowIndex++
    ) {
      var tableRow = document.createElement('tr');

      for (var columnIndex = 0; columnIndex < 3; columnIndex++) {
        var valueIndex = rowIndex * 3 + columnIndex;
        var tableCell = document.createElement('td');
        tableCell.classList.add('body-size-table-cell');

        if (valueIndex < values.length) {
          var value = getBodyMeasurementValue(values[valueIndex], unit);
          var inputId =
            'body-size-' + measurement.stateKey + '-' + unit + '-' + valueIndex;
          var input = document.createElement('input');
          input.type = 'radio';
          input.classList.add('btn-check');
          input.name = 'body-size-' + measurement.stateKey;
          input.id = inputId;
          input.value = value;
          input.autocomplete = 'off';
          input.checked =
            currentState &&
            currentState.unit === unit &&
            Number(currentState.value) === value;

          var label = document.createElement('label');
          label.classList.add('btn', 'btn-outline-info', 'body-size-table-btn');
          label.setAttribute('for', inputId);
          label.textContent = value;

          input.addEventListener('change', onChange);
          tableCell.appendChild(input);
          tableCell.appendChild(label);
        } else {
          tableCell.classList.add('body-size-table-cell-empty');
          tableCell.setAttribute('aria-hidden', 'true');
        }

        tableRow.appendChild(tableCell);
      }

      table.appendChild(tableRow);
    }

    parentElement.appendChild(table);
  }

  function renderBodySizeTables(tablesDiv, measurements, unit) {
    tablesDiv.replaceChildren();

    measurements.forEach((measurement) => {
      createBodyMeasurementTable(tablesDiv, measurement, unit, (event) => {
        currentValueList[measurement.stateKey] = {
          value: Number(event.target.value),
          unit: unit
        };
        saveCurrentValues();
        addPopDiv(
          tablesDiv.id,
          formatBodySizePopText(measurements),
          'bodySize'
        );
      });
    });
  }

  // Brami 显示下胸围；非 Brami 只显示胸围、腰围和臀围。
  function createBodySizeBtns(parentElement) {
    ['bust', 'underBust', 'waist', 'hip'].forEach((stateKey) => {
      currentValueList[stateKey] = { value: 0, unit: '' };
    });
    saveCurrentValues();

    var measurements = [
      { stateKey: 'bust', label: 'Bust', minValue: 30, maxValue: 46 }
    ];

    if (isBramiProduct()) {
      measurements.push({
        stateKey: 'underBust',
        label: 'Under Bust',
        minValue: 24,
        maxValue: 40
      });
    }

    measurements.push(
      { stateKey: 'waist', label: 'Waist', minValue: 23, maxValue: 40 },
      { stateKey: 'hip', label: 'Hip', minValue: 32, maxValue: 50 }
    );

    var btnGroupName = 'body-size-uom';
    var currentUnit = 'in';
    createRuleBtns(parentElement, btnGroupName, ['in', 'cm'], currentUnit);

    var tablesDiv = document.createElement('div');
    tablesDiv.classList.add('body-size-tables');
    tablesDiv.id = 'body-size-tables';
    parentElement.appendChild(tablesDiv);

    renderBodySizeTables(tablesDiv, measurements, currentUnit);

    var unitBtns = parentElement.querySelectorAll(
      'input[name="' + btnGroupName + '"]'
    );
    unitBtns.forEach((unitBtn) => {
      unitBtn.addEventListener('change', (event) => {
        var nextUnit = event.target.value;

        measurements.forEach((measurement) => {
          var state = currentValueList[measurement.stateKey];
          if (state && state.value && state.unit) {
            currentValueList[measurement.stateKey] = {
              value: convertBodyMeasurementValue(
                state.value,
                state.unit,
                nextUnit
              ),
              unit: nextUnit
            };
          }
        });

        currentUnit = nextUnit;
        saveCurrentValues();
        renderBodySizeTables(tablesDiv, measurements, currentUnit);

        var selectedText = formatBodySizePopText(measurements);
        if (selectedText) {
          addPopDiv(tablesDiv.id, selectedText, 'bodySize');
        }
      });
    });

    setTimeout(() => {
      var selectedText = formatBodySizePopText(measurements);
      addPopDiv(tablesDiv.id, selectedText || 'Rather not say', 'bodySize');
    }, 500);
  }

  // 请求参数统一用underbust，保存都是underBust
  function submitInfoToBack(parentElement) {
    requestBody.customer.age = currentValueList.age;
    requestBody.customer.height.value = currentValueList.height.value;
    requestBody.customer.height.unit = currentValueList.height.unit;
    requestBody.customer.weight.value = currentValueList.weight.value;
    requestBody.customer.weight.unit = currentValueList.weight.unit;
    requestBody.customer.bodyType = currentValueList.bodyType;
    requestBody.customer.bust = currentValueList.bust;
    requestBody.customer.underbust = isBramiProduct()
      ? currentValueList.underBust
      : { value: 0, unit: '' };
    requestBody.customer.waist = currentValueList.waist;
    requestBody.customer.hip = currentValueList.hip;
    requestBody.product.id = productId;
    requestBody.customer.email = window.customer?.email || '';
    requestBody.customer.uid = uid;

    window.oglLoading(true)
    window.ogl_fetch_ecowrd
      .post(submitUrl, requestBody)
      .then((responseData) => {
        var recommendations =
          responseData &&
            responseData.code === 0 &&
            Array.isArray(responseData.data)
            ? responseData.data
            : [];
        var responseMessage =
          responseData && typeof responseData.msg === 'string'
            ? responseData.msg
            : '';

        createRecommendSize(parentElement, recommendations, responseMessage);
      })
      .catch((error) => {
        console.error('Failed to get size recommendation:', error);
        createRecommendSize(
          parentElement,
          [],
          error && typeof error.msg === 'string' ? error.msg : ''
        );
      }).finally(() => {
        window.oglLoading(false)
      })
  }

  function createProductSuit(recommendation) {
    const product_suit_template = `
      <div class="product-suit">
        <div class="recommend-wrap">
          <img class="product-img" src="" alt="">
          <div style="width: 100%">
            <div class="recommend-title"></div>

            <div class="recommend-size">
              <div class="main-recommend">
                <div class="radio">
                  <label class="form-check-label">
                    <span class="recommend-size-value"></span>
                    <span class="label-span"></span>
                  </label>
                </div>

                <div class="progress" role="progressbar">
                  <div class="progress-bar"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="description">
          <p class="second-block"></p>
        </div>
      </div>
    `;

    var templateElement = document.createElement('template');
    templateElement.innerHTML = product_suit_template.trim();

    var productSuit = templateElement.content.firstElementChild;
    console.log('productSuit', productSuit)
    var productImg = productSuit.querySelector('.product-img');
    var recommendTitle = productSuit.querySelector('.recommend-title');
    var recommendSize = productSuit.querySelector('.recommend-size');
    var sizeValue = productSuit.querySelector('.recommend-size-value');
    var countrySizeLabel = productSuit.querySelector('.label-span');
    var progress = productSuit.querySelector('.progress');
    var progressBar = productSuit.querySelector('.progress-bar');
    var description = productSuit.querySelector('.second-block');

    productImg.src = productMainImage;

    if (recommendation) {
      var size = String(recommendation.size || '').trim();
      var category = String(recommendation.category || '').trim();
      var categoryName =
        SIZE_GUIDE_CATEGORY_MAP[category.toLowerCase()] || category;
      var countrySize = getCountrySizeValue(size) || '';
      var percent = getRandomSecure(80, 90);

      recommendTitle.textContent =
        (categoryName ? categoryName + ' ' : '') +
        'Size ' +
        size +
        ' is your best match!';
      sizeValue.textContent = size + ' ';
      if (countrySize) {
        countrySizeLabel.textContent = '(' + countrySize + ')';
        countrySizeLabel.style.fontSize = '16px';
      } else {
        countrySizeLabel.remove();
      }

      progress.setAttribute('aria-valuenow', percent);
      progressBar.style.width = percent + '%';
      progressBar.textContent = percent + '%';

      description.textContent = recommendation.desc || '';
    } else {
      recommendTitle.remove();
      recommendSize.replaceChildren();
      description.textContent =
        'Could you please fill in all the details so we can recommend the perfect size for you? This will help ensure the best fit! Questions? Contact us at service@oglmove.uk.';
    }

    return productSuit;
  }

  function getDirectChild(container, element) {
    if (!container || !element || !container.contains(element)) {
      return null;
    }

    var directChild = element;
    while (
      directChild.parentElement &&
      directChild.parentElement !== container
    ) {
      directChild = directChild.parentElement;
    }

    return directChild.parentElement === container ? directChild : null;
  }

  function createRecommendSize(parentElement, recommendations, message) {
    const result_html_template = `
      <div id="recommend-size-container" class="recommend-size-container">
        <h2 class="main-title"></h2>

        <div class="product-suit-list"></div>

        <form
          id="submit-email-form"
          class="needs-validation"
          novalidate="true"
        >
          <div class="form-group">
            <label for="email-input">
              Please leave your email to save your personal size profile.
            </label>

            <div class="email-input-wrap">
              <input
                id="email-input"
                class="form-control"
                type="email"
                required
                aria-describedby="email-invalid-feedback"
                placeholder="Enter your email address"
              >
              <button class="email-save-btn" type="submit">Save</button>
            </div>

            <div
              id="email-invalid-feedback"
              class="invalid-feedback"
              role="alert"
            >
              Please provide a valid Email.
            </div>
          </div>

          <div class="recommend-btns">
            <button
              class="btn t4s-btn t4s-btn-base t4s-btn-color-dark t4s-d-flex t4s-align-items-center continue-shopping-btn"
              type="button"
            >
              Continue Shopping
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="8"
                viewBox="0 0 19 8"
                fill="none"
              >
                <path
                  d="M18.3432 4.03519C18.5385 3.83993 18.5385 3.52335 18.3432 3.32809L15.1613 0.146107C14.966 -0.0491555 14.6494 -0.0491555 14.4542 0.146107C14.2589 0.341369 14.2589 0.657951 14.4542 0.853214L17.2826 3.68164L14.4542 6.51007C14.2589 6.70533 14.2589 7.02191 14.4542 7.21717C14.6494 7.41244 14.966 7.41244 15.1613 7.21717L18.3432 4.03519ZM0 3.68164L0 4.18164L17.9897 4.18164V3.68164V3.18164L0 3.18164L0 3.68164Z"
                  fill="white"
                />
              </svg>
            </button>
            <button class="btn btn-light edit-btn" type="button">
              Edit Info
            </button>
          </div>
        </form>
      </div>
    `;

    var modal = document.getElementById('what-my-size-modal');
    if (!modal) {
      console.warn('Missing what-my-size modal');
      return;
    }

    var templateElement = document.createElement('template');
    templateElement.innerHTML = result_html_template.trim();
    var recommendSizeWrap = templateElement.content.firstElementChild;
    var mainTitle = recommendSizeWrap.querySelector('.main-title');
    var productSuitList = recommendSizeWrap.querySelector('.product-suit-list');
    var form = recommendSizeWrap.querySelector('#submit-email-form');
    var formGroup = form.querySelector('.form-group');

    mainTitle.textContent =
      typeof message === 'string' && message.trim()
        ? message.trim()
        : 'Size not available';

    recommendations = Array.isArray(recommendations)
      ? recommendations.filter(
        (recommendation) =>
          recommendation &&
          typeof recommendation === 'object' &&
          String(recommendation.size || '').trim()
      )
      : [];

    if (recommendations.length) {
      recommendations.forEach((recommendation) => {
        productSuitList.appendChild(createProductSuit(recommendation));
      });
    } else {
      productSuitList.appendChild(createProductSuit(null));
    }

    if (window.customer) {
      formGroup.remove();
    }

    var modalContentDiv = modal.querySelector('.modal-content');
    if (!modalContentDiv) {
      console.warn('Missing what-my-size modal content');
      return;
    }

    var existingContainers = modalContentDiv.querySelectorAll(
      '#what-my-size-container, #recommend-size-container'
    );
    var replaceTarget = getDirectChild(modalContentDiv, parentElement);

    if (!replaceTarget && existingContainers.length) {
      replaceTarget = getDirectChild(modalContentDiv, existingContainers[0]);
    }

    if (replaceTarget) {
      modalContentDiv.replaceChild(recommendSizeWrap, replaceTarget);
    } else {
      modalContentDiv.appendChild(recommendSizeWrap);
    }

    for (var existingContainer of existingContainers) {
      if (!modalContentDiv.contains(existingContainer)) {
        continue;
      }

      var staleContainer = getDirectChild(
        modalContentDiv,
        existingContainer
      );
      if (
        staleContainer &&
        staleContainer !== recommendSizeWrap &&
        staleContainer.parentElement === modalContentDiv
      ) {
        staleContainer.remove();
      }
    }

    addRecommendSizeBtnsListener();
    setWhatMySizeEntryTitle(recommendations);
  }

  function hideEmailValidation(emailInput, invalidFeedback) {
    var inputWrap = emailInput.closest('.email-input-wrap');
    emailInput.setCustomValidity('');
    emailInput.removeAttribute('aria-invalid');
    inputWrap?.classList.remove('is-invalid');
    invalidFeedback?.classList.remove('is-visible');
  }

  function validateEmailInput(emailInput, invalidFeedback) {
    var email = emailInput.value.trim();
    var inputWrap = emailInput.closest('.email-input-wrap');

    emailInput.value = email;
    emailInput.setCustomValidity('');
    var isValid =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && emailInput.checkValidity();

    emailInput.setCustomValidity(
      isValid ? '' : 'Please provide a valid Email.'
    );
    emailInput.setAttribute('aria-invalid', String(!isValid));
    inputWrap?.classList.toggle('is-invalid', !isValid);
    invalidFeedback?.classList.toggle('is-visible', !isValid);

    return isValid;
  }

  function addRecommendSizeBtnsListener() {
    var modal = document.getElementById('what-my-size-modal');
    var form = document.querySelector('#submit-email-form');
    if (!modal || !form) {
      return;
    }

    var emailInput = form.querySelector('#email-input');
    var invalidFeedback = form.querySelector('#email-invalid-feedback');
    if (emailInput) {
      emailInput.value = window.customer?.email || ''
      emailInput.addEventListener('focus', () => {
        hideEmailValidation(emailInput, invalidFeedback);
      });
      emailInput.addEventListener('blur', () => {
        validateEmailInput(emailInput, invalidFeedback);
      });
    }

    form.addEventListener(
      'submit',
      function (event) {
        event.preventDefault();
        var emailIsValid =
          !emailInput || validateEmailInput(emailInput, invalidFeedback);
        if (!emailIsValid || form.checkValidity() === false) {
          event.stopPropagation();
        } else {
          var email = emailInput ? emailInput.value : '';
          var data = { uid: uid, email: email };

          if (email) {
            window.ogl_fetch_ecowrd.post(submitEmail, data).catch((error) => {
              console.error('Failed to save size profile email:', error);
            });
          }
          closeModal();
        }
        form.classList.add('was-validated');
      },
      false
    );

    var continueShoppingBtn = modal.querySelector(
      '#recommend-size-container .continue-shopping-btn'
    );
    if (continueShoppingBtn) {
      continueShoppingBtn.addEventListener('click', () => {
        closeModal()
        $('.t4s-ajax-popup-wrapper').click()
      });
    }

    var editBtn = modal.querySelector(
      '#recommend-size-container .recommend-btns .edit-btn'
    );
    if (editBtn) {
      editBtn.addEventListener('click', () => {
        count = 0;
        var container = document.createElement('div');
        container.id = 'what-my-size-container';
        var recommendSizeWrap = modal.querySelector(
          '#recommend-size-container'
        );
        var modalContentDiv = modal.querySelector('.modal-content');
        modalContentDiv.removeChild(recommendSizeWrap);
        modalContentDiv.appendChild(container);
        var modalFooter = modal.querySelector('.modal-footer');
        if (modalFooter) {
          modalFooter.style.display = '';
        }
        displayedList = createStepState();
        disabledList = createStepState();
        currentValueList = createDefaultCurrentValues();
        localSavedData = null;
        window.localStorage.removeItem(SELECTED_VALUES_STORAGE_KEY);
        createHeightDiv();
        updateSteps(1);
      });
    }
  }

  // 返回一个安全的随机数，范围为min到max（包括min和max）
  function getRandomSecure(min, max) {
    var array = new Uint32Array(1);
    window.crypto.getRandomValues(array);
    var randomNum = array[0] / (0xffffffff + 1);
    return Math.floor(randomNum * (max - min + 1) + min);
  }
})();
